import { createContext, ReactNode, useState } from "react";
import inputConf from "../ui-conf.json";
import {
  DEFAULT_UI_CONFIGURATION,
  MyLicensesConfiguration,
} from "./my-licenses-configuration";
import { mergeInDefaults, migrateConfToLatest } from "./configuration-tools";

export function applyConf(c: MyLicensesConfiguration): MyLicensesConfiguration {
  // store original version of conf, empty conf = use latest default and it's version
  const originalUIConfVersion: string = !!c.version
    ? c.version
    : Object.keys(c).length === 0
    ? (DEFAULT_UI_CONFIGURATION.version as string)
    : "0";
  // transform the inputted conf to the latest conf format
  const uiConf: MyLicensesConfiguration = migrateConfToLatest(c as any);
  // create the actual conf by merging together requested and matching default conf
  return mergeInDefaults(uiConf, originalUIConfVersion);
}

let conf: MyLicensesConfiguration = applyConf(inputConf as MyLicensesConfiguration);

const UIConfiguration = createContext<{
  conf: MyLicensesConfiguration;
  applyConf: (c: MyLicensesConfiguration) => void;
}>({ conf: conf, applyConf: (c: MyLicensesConfiguration) => {} }); //Initialise

export const InitialUIConfiguration = conf;
export default UIConfiguration;

export function UIConfigurationProvider(props: { children?: ReactNode }) {
  const { children } = props;
  const [stateConf, setConfValue] = useState(InitialUIConfiguration);
  return (
    <UIConfiguration.Provider
      value={{
        conf: stateConf,
        applyConf: (c) => {
          setConfValue(applyConf(c));
        },
      }}
    >
      {children}
    </UIConfiguration.Provider>
  );
}
